module.exports = __webpack_public_path__ + "lk.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/lk.svg
// module id = 662
// module chunks = 0